import Vue from 'vue'
import axios from 'axios'

axios.defaults.baseURL = 'https://gaspar.innboard.workers.dev/'
Vue.prototype.$http = axios